import React, { useCallback, useEffect, useState, KeyboardEvent } from "react";
import logo from "../../img/logo.png";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { ReactComponent as UserAccountIcon } from "../../img/account-circle.svg";
import { Modal } from "../../widgets/modal";
import TextField from "../../widgets/textField/textField";
import changePwd from "../../img/change-pwd.png";
import { LOGIN_DIALOGS } from "../../constants/dialog.constants";
import { CHANGE_PASSWORD_API, BASE_URL } from "../../constants/app.constants";
import { useMutation } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { changePassword } from "./changePassword.utils";
import Loader from "../../widgets/Loader";
import PasswordChecklist from "react-password-checklist";

interface HeaderProps {
  customer: string;
  contact?: string;
}

const Header: React.FC<HeaderProps> = ({ customer, contact }) => {
  const [isValid, setIsValid] = useState(false);
  const [oldPassword, setoldPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");

  const [confirmPassword, setconfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isChangePasswordWindowopen, setisChangePasswordWindowopen] =
    useState(false);
  const [isChangePasswordSubmit, setIsChangePasswordSubmit] = useState(false);
 const userId =
  localStorage.getItem("_k_Contact_ID") && localStorage.getItem("_k_Contact_ID") !== "undefined"
    ? localStorage.getItem("_k_Contact_ID")!
    : localStorage.getItem("ID") || "";

  const [toastMessage, setToastMessage] = useState("");
const [showToast, setShowToast] = useState(false);
const [toastFadeOut, setToastFadeOut] = useState(false);


  const navigate = useNavigate();

const displayToast = (message: string, duration = 3000) => {
  setToastMessage(message);
  setToastFadeOut(false);
  setShowToast(true);

  setTimeout(() => {
    setToastFadeOut(true); // trigger fade-out animation
  }, duration - 500);

  setTimeout(() => {
    setShowToast(false); // hide completely after fade-out
  }, duration);
};


  // Add proper type for the mutation response
  type ChangePasswordResponse = "success" | "notMatched" | "changepasswordfail";

  const { mutate, isPending, reset } = useMutation<
    ChangePasswordResponse,
    Error
  >({
    mutationFn: () => changePassword(userId, oldPassword, newPassword),
    onSuccess: (data) => {
      if (data === "success") {
         displayToast(LOGIN_DIALOGS.changePasswordSuccess); // show toast
    setisChangePasswordWindowopen(false);  
       
      } else if (data === "notMatched") {
        setErrorMessage(LOGIN_DIALOGS.incorrectPW);
      } else if (data === "changepasswordfail") {
        setErrorMessage(LOGIN_DIALOGS.technicalError);
      }
      clearFields();
    },
    onError: () => {
      setErrorMessage(LOGIN_DIALOGS.technicalError);
      clearFields();
    },
  });

  const clearFields = () => {
    setoldPassword("");
    setnewPassword("");
    setconfirmPassword("");
  };

  const changepasswordClick = useCallback(() => {
    setErrorMessage("");
    setSuccessMessage("");
    reset();
    setisChangePasswordWindowopen(true);
  }, [reset]);

  const cancelClick = useCallback(() => {
    setErrorMessage("");
    setoldPassword("");
    setnewPassword("");
    setconfirmPassword("");
    setisChangePasswordWindowopen(false);
  }, []);

  const onChangeFieldValues = useCallback(
    (id: string, updatedValue: string) => {
      if (id == "oldPassword") {
        setoldPassword(updatedValue);
      } else if (id == "newPassword") {
        setnewPassword(updatedValue);
      } else if (id == "confirmPassword") {
        setconfirmPassword(updatedValue);
      }
    },
    [oldPassword, newPassword, confirmPassword]
  );

  const submitChangePassword = useCallback(() => {
    if (oldPassword === "" || newPassword === "" || confirmPassword === "") {
      setErrorMessage("Please enter required details.");
    } else if (newPassword === oldPassword) {
      setErrorMessage("New Password cannot be same as Old Password.");
    } else if (newPassword !== confirmPassword) {
      setErrorMessage("New Password does not match with Confirm Password.");
    } else if (!isValid) {
      setErrorMessage(LOGIN_DIALOGS.invalidResetPassword);
    } else {
      setErrorMessage("");
      setIsChangePasswordSubmit(true);
      mutate();
    }
  }, [oldPassword, newPassword, confirmPassword, isValid]);

  const onLogOutSubmit = () => {
    window.sessionStorage.clear();
    window.localStorage.setItem("ID", "");
    window.localStorage.setItem("Name", "");
    window.localStorage.setItem("Person_ID", "");
    window.localStorage.setItem("AccountManagerID", "");
    window.localStorage.setItem("Intake_QuickbooksAccount", "");
    window.localStorage.setItem("Contact Name FL", "");
    window.localStorage.setItem("_k_Contact_ID", "");
    window.localStorage.setItem("username", "");
    navigate("/login");
  };

return (
  <header className="py-3">
    <div className="container-fluid">
      <div className="row flex-nowrap justify-content-between align-items-center">
        <div className="col pt-1">
          <Link
            className="text-muted"
            to={BASE_URL}
            reloadDocument
          >
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="col text-center customer-heading">
          <div className="customer-name">{customer}</div>
          {contact && contact.trim() !== "undefined" && (
  <div className="customer-contact">{contact}</div>
)}
        </div>

        <div className="col d-flex justify-content-end align-items-center">
          <div id="profile-dropdown">
            <Dropdown>
              <Dropdown.Toggle id="profile-dropdown-toggle">
                <UserAccountIcon width={30} height={30} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={changepasswordClick}>
                  Change Password
                </Dropdown.Item>
                <Dropdown.Item onClick={onLogOutSubmit}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>

    <Modal
      show={isChangePasswordWindowopen}
      label={"Change Password"}
      onClose={cancelClick}
    >
      <div className="changePwdSection">
        <div style={{ display: "flex", alignItems: "center", position: "relative", marginBottom: "80px", marginTop: "40px" }}>
          <div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
            <img src={changePwd} alt="Change Password" width={120} />
          </div>
        </div>

        {isPending ? <Loader /> : null}
        <div className="changePwdForm">
          <form>
            <div style={{ display: "flex", gap: "30px", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                <div className="formControlGroup">
                  <label className="formFieldLabel">Current Password:</label>
                  <TextField
                    id="oldPassword"
                    type="password"
                    value={oldPassword}
                    onChange={onChangeFieldValues}
                    className="email inputcls_cp"
                    placeholder="Enter Current Password"
                  />
                </div>
                <div className="formControlGroup">
                  <label className="formFieldLabel">New Password:</label>
                  <TextField
                    id="newPassword"
                    type="password"
                    value={newPassword}
                    onChange={onChangeFieldValues}
                    className="email inputcls_cp"
                    placeholder="Enter New Password"
                  />
                </div>
                <div className="formControlGroup">
                  <label className="formFieldLabel">Confirm Password:</label>
                  <TextField
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={onChangeFieldValues}
                    className="email inputcls_cp"
                    placeholder="Enter Confirm Password"
                  />
                </div>
              </div>

              <div style={{ minWidth: "250px", marginTop: "60px" }}>
                <PasswordChecklist
                  rules={["minLength", "specialChar", "number", "capital", "match"]}
                  minLength={5}
                  value={newPassword}
                  valueAgain={confirmPassword}
                  onChange={(isValid) => setIsValid(isValid)}
                />
              </div>
            </div>

            <div className="formControlGroup">
              <label className="formFieldLabel"></label>
              <div className="formField actionButtons">
                <button
                  type="button"
                  className="btn changePwdBtn"
                  onClick={submitChangePassword}
                >
                  Change Password
                </button>
                <button
                  type="button"
                  className="btn cancelPwdBtn"
                  onClick={cancelClick}
                >
                  Cancel
                </button>
              </div>
            </div>

            <div className="errorMsgStyle">{errorMessage}</div>
          </form>
        </div>
      </div>
    </Modal>

 {/* Toast / Snackbar */}
{showToast && (
  <div className={`toast-snackbar ${toastFadeOut ? "fade-out" : ""}`}>
    {toastMessage}
  </div>
)}

  </header>
);

};

export default Header;
